import { Section } from "../../entities/Section";
import { ISectionsRepository } from "../ISectionsRepository";
import response from '../../database/sections.json';

export class JsonSectionsRepository implements ISectionsRepository
{
    async findById(partId: number, sectionId: number): Promise<Section|null>
    {
        if (partId <= 0 || sectionId < 0) {
            return null;
        }

        const foundSection = response[partId][sectionId];

        const sectionData = {
            title: foundSection.title,
            link: foundSection.link
        };

        const section = new Section(sectionData, foundSection.paragraphs);

        return section;
    }

    async getPrologue(): Promise<Section|null>
    {
        const foundSection = response[0][0];

        const sectionData = {
            title: foundSection.title,
            link: foundSection.link
        };

        const prologue = new Section(sectionData, foundSection.paragraphs);
        return prologue;
    }
}